import instance from '../../apiInstance';

export const getProfiles = async (page) => {
  try {
    const response = await instance({
      method: 'get',
      url: `feed?page=${page}&page_size=15`,
    });
    return response.data;
  } catch (error) {
    return { urls: [], count: 0 };
  }
};

export const likePost = async (email) => {
  try {
    const response = await instance({
      method: 'put',
      url: `feed/likes-wallet?email=${email}`,
    });
    return response;
  } catch (error) {
    return null;
  }
};

export const wallet = async (walletId) => {
  try {
    const response = await instance({
      method: 'put',
      url: `feed/wallet?wallet=${walletId}`,
    });
    return response;
  } catch (error) {
    return null;
  }
};

export const userData = async () => {
  try {
    const response = await instance({
      method: 'get',
      url: `me`,
    });
    return response.data.user;
  } catch (error) {
    return null;
  }
};

// ── Roleta de Prêmios (User) ──

export const getMySpins = async () => {
  const res = await instance.get("/points/spins");
  return res.data;
};

export const executeSpin = async (surveyData = null) => {
  const res = await instance.post("/points/spin", surveyData || {});
  return res.data;
};

export const saveSpinPreferences = async (resultId, preferences) => {
  const res = await instance.put(`/points/spin/${resultId}/preferences`, { preferences });
  return res.data;
};
